import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Eyebrow, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionShell tone="cream" data-id="element-138" data-mp="123ob8tns2cwj">
      <Eyebrow data-id="element-139" data-mp="122vbicn8knnw">Dudas frecuentes</Eyebrow>
      <SectionTitle data-id="element-140" data-mp="1pro1ztl3a3b4">Preguntas frecuentes</SectionTitle>

      <div className="mt-8 space-y-2.5" data-id="element-141" data-mp="1pszf4k0fcnew">
        {faqs.map((faq, i) => {
        const open = openIndex === i;
        return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy-100 bg-white" data-id="element-142" data-mp="1g2nzw1bairsp" data-mpi={i}>
              <h3 data-id="element-143" data-mp="1l06adw4yhf2t">
                <button type="button" onClick={() => setOpenIndex(open ? null : i)} aria-expanded={open} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left sm:px-5" data-id="element-144" data-mp="1kzegcpr0bpen">
                  <span className="text-[14px] font-bold leading-snug text-navy-900 sm:text-[15.5px]" data-id="element-145" data-mp="2oqqnbgl8ili1">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-renal-600 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-146" data-mp="2ygjzojt7b4nc" />
                </button>
              </h3>
              {open && <p className="border-t border-navy-100 px-4 py-4 text-[13.5px] leading-relaxed text-navy-700/85 sm:px-5 sm:text-[14.5px]" data-id="element-147" data-mp="32glss4kvepr0">
                  {faq.a}
                </p>}
            </div>;
      })}
      </div>

      <div className="mt-8" data-id="element-148" data-mp="3cdyvc6a1s8nr">
        <CtaButton label="Resolver mis dudas y empezar ya" sub="Descarga inmediata • Pago único • Garantía de 7 días" data-id="element-149" data-mp="1n0d8o9n1mn42" />
      </div>
    </SectionShell>;
}